import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { LangService } from 'src/app/services/lang.service';
import { Lang } from 'src/app/models/lang';
import { Strings } from '../../const/strings';

@Component({
  selector: 'app-menu-dialog',
  templateUrl: './menu-dialog.component.html',
  styleUrls: ['./menu-dialog.component.scss']
})
export class MenuDialogComponent implements OnInit {

  appUrl: string;
  lang: Lang;
  strings = Strings;

  constructor(
    public dialogRef: MatDialogRef<MenuDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: object,
    private langService: LangService,
  ) { }

  ngOnInit() {
    this.appUrl = this.langService.getAppUrl();
    this.lang = this.langService.getCurrentLang();
  }

  @HostListener('window:resize', [ '$event' ])
  onWindowScroll(event: Event) {
    if (typeof window === 'undefined') {
      return;
    }
    if (window.innerWidth > 970) {
      this.close();
    }
  }

  close(): void {
    this.dialogRef.close();
  }

}
